import designDnaExtractionEngineMarkdown from '@/assets/Artifacts/design-dna-extraction-engine.md?raw'
import muiShowcaseWorklogMarkdown from '@/assets/Artifacts/mui-component-showcase-worklog.md?raw'
import muiShowcaseHtml from '@/assets/Artifacts/mui-showcase.html?raw'
import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import { buildStepNarration } from './stepNarrationCopy.js'



export const DESIGN_DNA_USER_PROMPT = `I am starting a new design for Web Application project:
Can you help me setting up a complete figma Design system directly importing components from latest MUI library to my Figma
 Here is my Moodboard link https://in.pinterest.com/chagi1548/webapp-ui-inspirations/`

export const DESIGN_DNA_MOODBOARD_URL =
  'https://in.pinterest.com/chagi1548/webapp-ui-inspirations/'

export const DESIGN_DNA_WORKED_LABEL = 'Worked for 22m 14s'

export const DESIGN_DNA_PLAN_WORKED_LABEL = 'Worked for 8m 42s'

export const DESIGN_DNA_GENERATION_WORKED_LABEL = 'Worked for 13m 32s'

export const DESIGN_DNA_PHASE1_THOUGHT_DETAILS = [
  `The user is starting a **Web Application** design and wants a complete **Figma design system** with the latest **MUI** components, guided by their Pinterest moodboard.`,
  `Before building anything, I'll share the **complete execution plan** and run the **AI Design DNA Extraction Engine** — reconstructing the visual operating system behind the references.`,
  `Plan of attack:

• **Phase A** — Ingest moodboard, classify references, extract tokens, map MUI overrides, emit the 13-phase Design DNA report
• **Phase B** — Import the latest MUI library on the M3 baseline and apply the Design DNA transformation map
• **Phase C** — You pick the Figma **project**; I create the library **file** there and publish variables + components`,
  `I'll deliver the plan and key findings in chat with the full \`design-dna-extraction-engine.md\` report attached, then wait for confirmation before generating the showcase.`,
]

export const DESIGN_DNA_PHASE2_THOUGHT_DETAILS = [
  `The user confirmed the plan — proceeding with **MUI showcase generation** using the extracted Design DNA.`,
  `Build approach: import the latest MUI library on the **M3 light scheme** baseline, apply the Design DNA transformation map (shape, elevation, type ramp), and export \`MUI Component Showcase.html\` for live preview.`,
  `Handing the build to the software-engineering agent — once the showcase is verified, you'll pick which Figma **project** receives the new library file.`,
]

export const DESIGN_DNA_COMPLETE_PLAN_MARKDOWN = `I'll set up your **Figma design system** from the latest **MUI** library, guided by your Pinterest moodboard ([WebApp UI Inspirations](${DESIGN_DNA_MOODBOARD_URL})). Here is the full plan:

### Phase A — Design DNA Extraction
1. **Ingest moodboard** — 13 pins (dashboards, settings, analytics, tables)
2. **Classify references** — layout, visual, and UX layers
3. **Extract visual signals** — dark surfaces, rounded cards, subtle borders, sidebar layouts, blue accents
4. **Generate design tokens** — color, radius, spacing, typography
5. **Map to MUI overrides** — shape, elevation, palette transformations
6. **Produce internal report** — full 13-phase \`design-dna-extraction-engine.md\` document

### Phase B — Component Showcase Build
1. **Import the latest MUI library** on the stock **Material Theme (M3)** light scheme baseline
2. **Apply the Design DNA transformation map** — 12–20px radii, border-first elevation, editorial type ramp
3. **Build & verify 60+ components** — inputs, data display, feedback, surfaces, navigation, MUI X
4. **Export artifact** — single-file \`MUI Component Showcase.html\` for live preview

### Phase C — Figma Handoff
1. **You choose the Figma project** (destination workspace)
2. **I create a new library file** in that project and publish the variable collections + MUI component sets from the showcase`

export const DESIGN_DNA_PROCEED_CTA_MARKDOWN =
  '**Do you want to proceed with the plan?** Reply **yes** when you\'re ready and I\'ll start generating the MUI showcase and preparing the Figma handoff.'

export const DESIGN_DNA_THOUGHT_DETAILS = DESIGN_DNA_PHASE1_THOUGHT_DETAILS

export const DESIGN_DNA_OPENING_CALLOUT =
  'Moodboard received — I analyzed all **13 pins** and ran the **AI Design DNA extraction**. Below: the complete execution plan, the key findings, and the full internal report.'

export const DESIGN_DNA_OBJECTIVE_MARKDOWN =
  "*The goal isn't to identify what the references look like — it's **why** they look that way. These are the dominant signals reconstructed from the moodboard.*"
